<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="7"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量" clearable></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
						</m-search-item>
						<m-search-item label="接驳时间" colspan="2">
							<c-datetime range start-name="handover_start_date" end-name="handover_end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_quality_list_add_report')" prepend-icon="tf-add" color="main" @click="addBQualityReport">添加B端报告</c-button>
                    <c-button v-if="auth('b_quality_list_add_report')" prepend-icon="tf-add" color="main" @click="addCQualityReport">添加C端报告</c-button>
                    <c-button v-if="auth('b_quality_report_publish')" prepend-icon="tf-shelf" color="green" @click="openReportTypeDialog('publish')">批量发布报告</c-button>
                    <c-button v-if="auth('b_quality_report_publish')" prepend-icon="tf-offshelf" color="red" :hollow="true" @click="openReportTypeDialog('unpublish')">批量下架报告</c-button>
                    <c-button v-if="hasHandover && auth('b_quality_list_transfer')" prepend-icon="tf-transfer" @click="openTransfer()">批量调拨</c-button>
                    <c-button v-if="hasHandover && auth('b_quality_list_return')" prepend-icon="tf-return-stock" @click="batchReturnToStock()">批量返库</c-button>
                    <c-button v-if="hasHandover && auth('b_quality_handover_confirm_reject')" prepend-icon="tf-batch" @click="confirmReject()">批量同意驳回</c-button>
					<c-button v-if="auth('b_quality_list_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_quality_report_publish')" prepend-icon="tf-shelf" color="green" @click="openReportTypeDialog('publish', data)">批量发布报告</c-button>
					<c-button v-if="auth('b_quality_report_publish')" prepend-icon="tf-offshelf" color="red" :hollow="true" @click="openReportTypeDialog('unpublish', data)">批量下架报告</c-button>
					<c-button v-if="hasHandover && auth('b_quality_list_transfer')" prepend-icon="tf-transfer" @click="openTransfer(data)">批量调拨</c-button>
					<c-button v-if="hasHandover && auth('b_quality_list_return')" prepend-icon="tf-return-stock" @click="batchReturnToStock(data)">批量返库</c-button>
                    <c-button v-if="hasHandover && auth('b_quality_handover_confirm_reject')" prepend-icon="tf-batch" @click="confirmReject(data)">批量同意驳回</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_quality_list_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

                <template #produce_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

                <template #purchase_price="{data}">
                    {{formatPrice(data.purchase_price)}}
                </template>

                <template #cost_price="{data}">
                    {{formatPrice(data.cost_price)}}
                </template>

                <template #in_stock_days="{data}">
                    {{formatDay(data.in_stock_days)}}
                </template>

                <template #in_transit_days="{data}">
                    <span :style="{color: data.in_transit_days > 2 ? '#e53e3e' : ''}">{{formatDay(data.in_transit_days)}}</span>
                </template>

                <template #product_state="{data}">
                    <span v-if="sourceHandoverStateText(data)" :style="{color: isSourceRejectPending(data) ? '#e53e3e' : ''}">{{sourceHandoverStateText(data)}}</span>
					<c-state v-else dict="productStateDic" :value="data.product_state"></c-state>
				</template>

                <template #handover_state="{data}">
					<c-state dict="ACCEPT_REJECT_STATE" :value="data.handover_state_show"></c-state>
				</template>

                <template #b_report_state="{data}">
                    <c-state dict="qualityReportStateDic" :value="data.b_report_state || 0"></c-state>
                </template>

                <template #c_report_state="{data}">
                    <c-state dict="qualityReportStateDic" :value="data.c_report_state || 0"></c-state>
                </template>

                <template #quality_state_store="{data}">
                    <c-state dict="qualityStateDic" :value="data.quality_state_store"></c-state>
                </template>

				<template #quality_state="{data}">
					<c-state dict="qualityStateDic" :value="data.quality_state"></c-state>
				</template>

				<template #b_quality_report="{data}">
					<span v-if="data.b_quality_report" style="color: green;">&#10004;</span>
				</template>

				<template #c_quality_report="{data}">
					<span v-if="data.c_quality_report" style="color: green;">&#10004;</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="260"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_quality_list_view_report') && data.buttons?.view_report?.visible" icon="tf-detail" @click="viewReport(data)">查看报告</c-table-button>
                        <c-table-button v-if="auth('b_quality_list_edit_report') && data.buttons?.edit_b_report?.visible" icon="tf-edit" @click="editBReport(data)">编辑B端报告</c-table-button>
                        <c-table-button v-if="auth('b_quality_list_edit_report') && data.buttons?.edit_c_report?.visible" icon="tf-edit" @click="editCReport(data)">编辑C端报告</c-table-button>
                        <c-table-button v-if="auth('b_quality_report_publish') && data.buttons?.publish_b_report?.visible" icon="tf-shelf" color="green" @click="batchPublish(1, [data])">发布B端报告</c-table-button>
                        <c-table-button v-if="auth('b_quality_report_publish') && data.buttons?.publish_c_report?.visible" icon="tf-shelf" color="green" @click="batchPublish(2, [data])">发布C端报告</c-table-button>
                        <c-table-button v-if="auth('b_quality_report_publish') && data.buttons?.unpublish_b_report?.visible" icon="tf-offshelf" color="red" @click="batchUnpublish(1, [data])">下架B端报告</c-table-button>
                        <c-table-button v-if="auth('b_quality_report_publish') && data.buttons?.unpublish_c_report?.visible" icon="tf-offshelf" color="red" @click="batchUnpublish(2, [data])">下架C端报告</c-table-button>
                        <c-table-button v-if="auth('b_quality_list_transfer') && data.buttons?.transfer?.visible" icon="tf-transfer" @click="openTransfer([data])">调拨</c-table-button>
                        <c-table-button v-if="auth('b_quality_list_return') && data.buttons?.return_to_stock?.visible" icon="tf-return-stock" @click="batchReturnToStock([data])">返库</c-table-button>
                        <c-table-button v-if="auth('b_quality_handover_confirm_reject') && data.buttons?.confirm_reject?.visible" icon="tf-accept" @click="confirmReject(data)">同意驳回</c-table-button>
						<c-table-button v-if="auth('b_quality_list_upload_image') && data.buttons?.upload_image?.visible" icon="tf-upload" @click="uploadImage(data)">上传图片</c-table-button>
						<c-table-button v-if="auth('b_quality_list_update_imei') && data.buttons?.update_imei?.visible" icon="tf-edit" @click="updateImei(data)">修改串号</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--调拨弹窗（质检中直调：目标质检/维修/销售）-->
			<code-transfer ref="codeTransfer" :allow-states="[12]" dialog-title="质检调拨" @resolve="$refs.view.update()"></code-transfer>
			<!--批量发布/下架报告类型选择弹窗（B端、C端默认全选）-->
			<c-dialog ref="reportTypeDialog" :title="batchReportAction === 'publish' ? '批量发布报告' : '批量下架报告'" width="400" @resolve="submitBatchReport">
				<div class="m-report-type">
					<c-checkbox v-model="reportTypeChecked.b">B端报告</c-checkbox>
					<c-checkbox v-model="reportTypeChecked.c">C端报告</c-checkbox>
				</div>
			</c-dialog>
		</module>
	</page>
</template>

<script>
    import handoverReject from '@/mixins/handover_reject';
	import {mapState, mapGetters} from 'vuex'
	import codeTransfer from "@/pages/storage/code_transfer.vue";

	export default {
        mixins: [handoverReject],
        handoverModuleType: 1,
		components: {codeTransfer},

		data() {
			return {
				//批量弹框当前操作类型：publish 发布 / unpublish 下架
				batchReportAction: 'publish',
				//本次批量操作涉及的行集
				batchReportList: [],
				//弹框勾选的报告类型（B端、C端默认全选）
				reportTypeChecked: {b: true, c: true}
			}
		},

		computed: {
			...mapState(['testStateQualityDic', 'qualityReportStateDic', 'productStateDic', 'handoverStateDic']),
			//版本能力开关（登录时由服务端下发）：门店版无接驳与调拨，页内调拨/返库入口整体不露
			...mapGetters(['hasHandover'])
		},

		methods: {

			/*********发起调拨（质检中→维修/销售，支持扫码补充）**********/
			openTransfer(data) {
				let list = [];
				if (data && data.length) {
					list = data;
				} else {
					list = this.$refs.view.$refs.list.getData('selected');
				}
				if (!list.length) {
					this.$message({message: '请选择要调拨的记录', type: 'warning'});
					return;
				}
				this.$refs.codeTransfer.open(list);
			},
            /*********格式化价格**********/
            formatPrice(price) {
                if (price === null || price === undefined || price === '') return '-';
                return '¥' + parseFloat(price).toFixed(2);
            },
            formatDay(day) {
                if (day === null || day === undefined || day === '') return '-';
                return parseInt(day) + '天';
            },
            /*********获取产品信息文字**********/
            getProductText(data) {
                var parts = [];
                if (data.brand_name) parts.push(data.brand_name);
                if (data.model_name) parts.push(data.model_name);
                if (data.color_name) parts.push(data.color_name);
                if (data.memory_name) parts.push(data.memory_name);
                return parts.join(' ') || '-';
            },
			/*********添加B端质检报告************/
			addBQualityReport() {
				this.openReportScan(1);
			},

            /*********添加C端质检报告************/
            addCQualityReport() {
                this.openReportScan(2);
            },

            editBReport(data) {
               let editReportParam = {};
               editReportParam.report_type = 1;
               editReportParam.product_code_id = data.product_code_id;
               editReportParam.produce_unique_code = data.produce_unique_code;
               this.editReport(editReportParam)
            },
            editCReport(data) {
                let editReportParam = {};
                editReportParam.report_type = 2;
                editReportParam.product_code_id = data.product_code_id;
                editReportParam.produce_unique_code = data.produce_unique_code;
                this.editReport(editReportParam)
            },

            editReport(data) {
                this.navigateTo({
                    name: 'm_quality_report_edit',
                    query: {
                        product_code_id: data.product_code_id,
                        produce_unique_code: data.produce_unique_code,
                        report_type: data.report_type,
                    }
                });
            },

			/*********打开扫码弹框并跳转编辑页************/
			openReportScan(reportType) {
				this.globalDialog('qualityReportScan', {
					props: {
						reportType: reportType
					}
				}, (productData) => {
					this.navigateTo({
						name: 'm_quality_report_edit',
						query: {
							product_code_id: productData.product_code_id,
							produce_unique_code: productData.produce_unique_code,
							report_type: reportType
						}
					});
				});
			},

			/*********查看报告************/
			viewReport(data) {
				this.globalDialog('qualityReportView', {data} );
			},

			/*********批量确认返库************/
			batchReturnToStock(data) {
				let list = [];
				if (data && data.length) {
					list = data;
				} else {
					list = this.$refs.view.$refs.list.getData('selected');
				}
				if (!list.length) {
                    this.$message({message: '请选择要返库的记录', type: 'warning'});
                    return;
                }
				let tipMsg = list.length === 1
						? '确认将该商品返库吗？'
						: '确认将选中的 ' + list.length + ' 条记录返库吗？';
				this.$confirm({
					message: tipMsg,
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/quality/return',
							data: {product_code_ids: list.map(item => item.product_code_id).join(',')},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********上传图片************/
			uploadImage(data) {
				this.globalDialog('qualityUploadImage', {
					data: data
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********修改临时串号************/
			updateImei(data) {
				this.globalDialog('qualityUpdateImei', {
					data: data
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********打开发布/下架报告类型选择弹窗（批量入口）**********/
			openReportTypeDialog(action, data) {
				let list = [];
				if (data && data.length) {
					list = data;
				} else {
					list = this.$refs.view.$refs.list.getData('selected');
				}
				if (!list.length) {
					this.$message({message: action === 'publish' ? '请选择要发布报告的商品' : '请选择要下架报告的商品', type: 'warning'});
					return;
				}
				this.batchReportAction = action;
				this.batchReportList = list;
				this.reportTypeChecked = {b: true, c: true};
				this.$refs.reportTypeDialog.open();
			},

			/*********批量弹窗确定后按勾选类型提交（发布/下架均走多端合并接口，一次请求承接B+C）**********/
			submitBatchReport(stop, next) {
				stop();
				let types = [];
				if (this.reportTypeChecked.b) types.push(1);
				if (this.reportTypeChecked.c) types.push(2);
				if (!types.length) {
					this.$message({message: '请至少勾选一种报告类型', type: 'warning'});
					return;
				}
				let isPublish = this.batchReportAction === 'publish';
				// 不按行按钮可见性拦截：勾选行里该端报告ID全部提交给后端二次校验（能操作的直接处理，不合格的回失败明细）；
				// 商品没有该端报告的发不出去（后端无从感知），就地记入失败明细一并展示
				let localBlocks = [];
				let idsByType = {};
				types.forEach(type => {
					let typeName = type == 1 ? 'B端' : 'C端';
					let ids = [];
					this.batchReportList.forEach(item => {
						let id = type == 1 ? item.b_report_id : item.c_report_id;
						if (id) {
							ids.push(id);
						} else {
							localBlocks.push({
								produce_unique_code: item.produce_unique_code || '-',
								report_type_name: typeName,
								reason: isPublish ? '该商品没有' + typeName + '报告，请先添加' : '该商品没有' + typeName + '报告，无需下架'
							});
						}
					});
					idsByType[type] = ids.join(',');
				});
				//B端+C端合并为一个结果，统一走一个失败明细弹框（publish_count 统一按成功份数计）
				let merged = {op_type: isPublish ? 'publish' : 'unpublish', publish_count: 0, block_count: localBlocks.length, block_list: localBlocks};
				let mergeRes = (res) => {
					if (!res) return;
					merged.publish_count += (isPublish ? res.publish_count : res.unpublish_count) || 0;
					merged.block_count += res.block_count || 0;
					merged.block_list = merged.block_list.concat(res.block_list || []);
				};
				let showResult = () => {
					this.$nextTick(() => {
						if (merged.block_list.length) {
							this.globalDialog('qualityPublishResult', {data: merged});
							return;
						}
						this.$message({message: isPublish ? '批量发布成功' : '批量下架成功', type: 'success'});
					});
				};
				// 弹框先关，请求由页面主体承接：整批拦回场景只弹错误提示，已成功的部分照常落库回显
				next();
				if (!idsByType[1] && !idsByType[2]) {
					//勾选行全部没有对应报告，没有可发的请求，直接展示失败明细
					showResult();
					return;
				}
				// 多端合并接口一次受理 B端+C端，后端合并校验与明细后一次回传，不存在串行半态
				this.request({
					url: isPublish ? '/quality/report/batchPublishMulti' : '/quality/report/batchUnpublishMulti',
					data: {b_report_ids: idsByType[1] || '', c_report_ids: idsByType[2] || ''},
					loading: true,
					success: (res) => {
						mergeRes(res);
						this.$refs.view.update();
						showResult();
					}
				});
			},

			/*********行内发布报告（单条直接发对应端；批量走类型选择弹窗）**********/
			batchPublish(reportType, data) {
				let list = [];
				if (data && data.length) {
					list = data;
				} else {
					list = this.$refs.view.$refs.list.getData('selected');
				}
				if (!list.length) {
					this.$message({message: '请选择要发布的报告', type: 'warning'});
					return;
				}
				// 不裁剪提交集，全部交给后端二次校验
				let key = reportType == 1 ? 'publish_b_report' : 'publish_c_report';
				let reportIds = list.filter(item => item.buttons && item.buttons[key] && item.buttons[key].visible)
						.map(item => reportType == 1 ? item.b_report_id : item.c_report_id)
						.filter(id => id).join(',');
				if (!reportIds) {
					this.$message({message: '没有可发布的报告', type: 'warning'});
					return;
				}
				let typeName = reportType == 1 ? 'B端' : 'C端';
				let tipMsg = list.length === 1
						? '确认发布该商品的【' + typeName + '】质检报告吗？'
						: '确认发布 ' + list.length + ' 条【' + typeName + '】质检报告吗？';
				this.$confirm({
					message: tipMsg,
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/quality/report/batchPublish',
							data: {report_ids: reportIds, report_type: reportType},
							loading: true,
							success: (res, msg) => {
								this.$refs.view.update();
								var blockList = (res && res.block_list) || [];
								if (blockList.length) {
									this.$nextTick(() => {
										this.globalDialog('qualityPublishResult', {data: res});
									});
									return;
								}
								this.$message({message: msg || '批量发布成功', type: 'success'});
							}
						});
					}
				});
			},

			/*********行内下架报告（单条直接下架对应端；批量走类型选择弹窗）**********/
			batchUnpublish(reportType, data) {
				let list = [];
				if (data && data.length) {
					list = data;
				} else {
					list = this.$refs.view.$refs.list.getData('selected');
				}
				if (!list.length) {
					this.$message({message: '请选择要下架的报告', type: 'warning'});
					return;
				}
				let key = reportType == 1 ? 'unpublish_b_report' : 'unpublish_c_report';
				let reportIds = list.filter(item => item.buttons && item.buttons[key] && item.buttons[key].visible)
						.map(item => reportType == 1 ? item.b_report_id : item.c_report_id)
						.filter(id => id).join(',');
				if (!reportIds) {
					this.$message({message: '没有可下架的报告', type: 'warning'});
					return;
				}
				let typeName = reportType == 1 ? 'B端' : 'C端';
				let tipMsg = list.length === 1
						? '确认下架该商品的【' + typeName + '】质检报告吗？'
						: '确认下架 ' + list.length + ' 条【' + typeName + '】质检报告吗？';
				this.$confirm({
					message: tipMsg,
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/quality/report/batchUnpublish',
							data: {report_ids: reportIds, report_type: reportType},
							loading: true,
							success: (res, msg) => {
								this.$refs.view.update();
								var blockList = (res && res.block_list) || [];
								if (blockList.length) {
									this.$nextTick(() => {
										this.globalDialog('qualityPublishResult', {data: Object.assign({op_type: 'unpublish'}, res)});
									});
									return;
								}
								this.$message({message: msg || '批量下架成功', type: 'success'});
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-report-type {
		padding: 20px 15px;
		display: flex;
		gap: 30px;
		font-size: 14px;
	}
</style>
